// import components
import ServiceIcon1 from '../../Icons/Home-page/ServiceIcon1';
import ServiceIcon2 from '../../Icons/Home-page/ServiceIcon2';
import ServiceIcon3 from '../../Icons/Home-page/ServiceIcon3';
import ServiceIcon4 from '../../Icons/Home-page/ServiceIcon4';
import ServiceIcon5 from '../../Icons/Home-page/ServiceIcon5';
import ServiceIcon6 from '../../Icons/Home-page/ServiceIcon6';
import ServiceIcon7 from '../../Icons/Home-page/ServiceIcon7';
import ServiceIcon8 from '../../Icons/Home-page/ServiceIcon8';
import ServiceIcon9 from '../../Icons/Home-page/ServiceIcon9';
import ServiceIcon10 from '../../Icons/Home-page/ServiceIcon10';
import ServiceIcon11 from '../../Icons/Home-page/ServiceIcon11';
import ServiceIcon12 from '../../Icons/Home-page/ServiceIcon12';
import ServiceIcon13 from '../../Icons/Home-page/ServiceIcon13';
import ServiceIcon14 from '../../Icons/Home-page/ServiceIcon14';
import ServiceIcon15 from '../../Icons/Home-page/ServiceIcon15';
import ContactUsIcon1 from '../../Icons/Home-page/ContactUsIcon1';
import ContactUsIcon2 from '../../Icons/Home-page/ContactUsIcon2';
import ContactUsIcon3 from '../../Icons/Home-page/ContactUsIcon3';
import ContactUsIcon4 from '../../Icons/Home-page/ContactUsIcon4';
import ContactUsIcon5 from '../../Icons/Home-page/ContactUsIcon5';
import ContactUsIcon6 from '../../Icons/Home-page/ContactUsIcon6';
import ContactUsIcon7 from '../../Icons/Home-page/ContactUsIcon7';
import image1 from '../../images/Home-page/landing-image1.png';
import image2 from '../../images/Home-page/landing-image2.jpg';
import image3 from '../../images/Home-page/landing-image3.jpg';

export const landingItem = [
	{
		src: image2,
		text: "بناء وتأثيث مدرسة ابتدائية بمساحة 5500 م2 لتعليم ذوي الاحتياجات الخاصة."
	},
	{
		src: image3,
		text: "بناء وتأسيس مشفى لمساعدة مرضى سرطان الأطفال بتكلفة تصل لمليون دولار"
	},
	{
		src: image1,
		text: "بناء وتأسيس جمعية خيرية بهدف أغاثة المتضررين من الصراعات الدولية"
	}
]

export const serviceItem = [	
	{ text: "مشاريع رمضان", logo: <ServiceIcon1 /> },
	{ text: "صحة", logo: <ServiceIcon2 /> },
	{ text: "كفالة اليتيم", logo: <ServiceIcon3 /> },
	{ text: "إخراج الزكاة", logo: <ServiceIcon4 /> },
	{ text: "تعليم", logo: <ServiceIcon5 /> },
	{ text: "بيوت الفقراء", logo: <ServiceIcon6 /> },
	{ text: "ذوي الهمم", logo: <ServiceIcon9 /> },
	{ text: "غذاء", logo: <ServiceIcon8 /> },
	{ text: "إكساء", logo: <ServiceIcon11 /> },
	{ text: "إغاثة", logo: <ServiceIcon12 /> },
	{ text: "مسجد", logo: <ServiceIcon7 /> },
	{ text: "صدقة", logo: <ServiceIcon14 /> },
	{ text: "أضحية", logo: <ServiceIcon10 /> },
	{ text: "إطعام مسكين", logo: <ServiceIcon13 /> },
	{ text: "إسكان", logo: <ServiceIcon15 /> },
]

export const contactUsItem = [
	{ text: "988311840 963+", logo: <ContactUsIcon1 /> },
	{ text: "8353983 011", logo: <ContactUsIcon2 /> },
	{ text: "Ataa2022@outlook.com", logo: <ContactUsIcon3 /> },
	{ text: "دمشق - كفرسوسة - مقابل شام سيتي سنتر", logo: <ContactUsIcon4 /> },
	{ text: "988311840 963+", logo: <ContactUsIcon5 /> },
	{ text: "Ataa Charity", logo: <ContactUsIcon6 /> },
	{ text: "Ataa Charity", logo: <ContactUsIcon7 /> },
]